import * as React from 'react'; // tslint:disable-line

import { Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { GFInitialState } from '../../models/models';
import { selectIsSuperTeacher, selectIsTeacher } from '../../reducers/userReducer';
import { connect } from 'react-redux';

const FontAwesome = require('react-fontawesome');
const mixpanel = require('mixpanel-browser');

interface Props {
  isTeacher: boolean;
  isSuperTeacher: boolean;
}

const MainMenu = ({ isTeacher, isSuperTeacher }: Props) => {
  function handleWritingAssignment(link: string) {
    mixpanel.track('Writing Activities clicked', { link });
  }

  const location = window.location.pathname;

  const isActive = (to: string) => {
    return window.location.pathname === to || window.location.pathname.startsWith(to);
  }

  return (
    <Nav bsStyle="pills" stacked={true} activeKey={1} className="gf-nav">
      {isTeacher && (
        // @ts-ignore
        <LinkContainer to="/classes" active={isActive('/classes')}>
          <NavItem eventKey={1}>
            <FontAwesome name="th-large" /> View Dashboard
          </NavItem>
        </LinkContainer>
      )}
      {isTeacher && (
        // @ts-ignore
        <LinkContainer to="/buildSuperDiagnostic" active={isActive('/buildSuperDiagnostic')}>
          <NavItem eventKey={1}>
            <FontAwesome name="th-list" key="solid" /> Build Diagnostic
          </NavItem>
        </LinkContainer>
      )}
      {isTeacher && (
        // @ts-ignore
        <LinkContainer to="/super-diagnostic-report-class" active={isActive('/super-diagnostic-report-class')}>
          <NavItem eventKey={3}>
            <FontAwesome name="trophy" /> View Diagnostic Results
          </NavItem>
        </LinkContainer>
      )}
      {(
        // @ts-ignore
        <LinkContainer to="/courses" active={isActive('/courses') || isActive('/courseLessons')}>
          <NavItem eventKey={5}>
            <FontAwesome name="book" /> View Lessons
          </NavItem>
        </LinkContainer>
      )}
      {isTeacher && (
        // @ts-ignore
        <LinkContainer to="/customLessons" active={isActive('/customLessons')}>
          <NavItem eventKey={6}>
            <FontAwesome name="address-card" /> Customize Lessons
          </NavItem>
        </LinkContainer>
      )}
      {isTeacher && (
        // @ts-ignore
        <LinkContainer to="/classprogress" active={isActive('/classprogress') || isActive('/studentprogress') || isActive('/performance-metrics')}>
          <NavItem eventKey={3}>
            <FontAwesome name="trophy" /> View Progress Reports
          </NavItem>
        </LinkContainer>
      )}
      {isTeacher && (
        // @ts-ignore
        <LinkContainer to="/gradingwritingassignment" active={isActive('/gradingwritingassignment')}>
          <NavItem
            eventKey={4}
            onClick={() => {
              handleWritingAssignment('/gradingwritingassignment');
            }}
          >
            <FontAwesome name="file-text" /> View Writing Portals
          </NavItem>
        </LinkContainer>
      )}
      {isTeacher && (
        // @ts-ignore
        <LinkContainer to="/students" active={isActive('/students')}>
          <NavItem eventKey={2}>
            <FontAwesome name="users" /> Manage Students
          </NavItem>
        </LinkContainer>
      )}
      {isSuperTeacher && (
        // @ts-ignore
        <LinkContainer to="/teachers" active={isActive('/teachers')}>
          <NavItem eventKey={2}>
            <FontAwesome name="graduation-cap" /> Manage Teachers
          </NavItem>
        </LinkContainer>
      )}
    </Nav>
  );
};

const mapStateToProps = (state: GFInitialState, ownProps: any) => {
  return {
    isTeacher: selectIsTeacher(state),
    isSuperTeacher: selectIsSuperTeacher(state),
  };
};

export default connect(
  mapStateToProps,
)(MainMenu);
